import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "RiskPedia SG";
const SITE_URL = process.env.REACT_APP_BACKEND_URL?.replace("/api", "") || "https://sg-riskguide.preview.emergentagent.com";
const DEFAULT_OG = "https://customer-assets.emergentagent.com/job_sg-riskguide/og-default.png"; // can be replaced later

export default function SEO({ title, description, keywords = [], path = "/", image, type = "website", jsonLd }) {
  const fullTitle = title ? `${title} · ${SITE}` : `${SITE} — Singapore Risk Encyclopedia`;
  const desc = description || "Singapore-localised risk, compliance and regulatory hub. MAS, PDPC, CSA frameworks, 12 wizards, workflow templates, CSRS score and live S$NEER.";
  const kw = [...new Set([...keywords, "Singapore", "MAS", "PDPA", "GRC", "compliance"])].filter(Boolean).join(", ");
  const url = `${SITE_URL}${path}`;
  const ogImage = image || DEFAULT_OG;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta name="keywords" content={kw} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content={SITE} />
      <meta property="og:locale" content="en_SG" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={ogImage} />

      {/* JSON-LD structured data */}
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
